import { render, staticRenderFns } from "./MateriaDetalle.vue?vue&type=template&id=55ee9a6c&scoped=true"
import script from "./MateriaDetalle.vue?vue&type=script&lang=js"
export * from "./MateriaDetalle.vue?vue&type=script&lang=js"
import style0 from "./MateriaDetalle.vue?vue&type=style&index=0&id=55ee9a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee9a6c",
  null
  
)

export default component.exports